// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Oker","controls":"styles_controls__3Kvzp","charLimit":"styles_charLimit__3FEwS","input":"styles_input__LKvin","send":"styles_send__2GMzw"};